import { render, staticRenderFns } from "./SatisTanimlar.vue?vue&type=template&id=21cf17f4&scoped=true"
import script from "./SatisTanimlar.vue?vue&type=script&lang=js"
export * from "./SatisTanimlar.vue?vue&type=script&lang=js"
import style0 from "./SatisTanimlar.vue?vue&type=style&index=0&id=21cf17f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf17f4",
  null
  
)

export default component.exports